import { Tooltip } from '@pocketlaw/tetris';
import { ButtonContainer, InnerBox, OuterBox } from './styled';
export function LayoutToggleButton(props) {
    const { open, side, tooltip, onClick } = props;
    return (<Tooltip title={tooltip} side={side === 'left' ? 'right' : 'left'}>
      <ButtonContainer $open={open} aria-label={tooltip} onClick={onClick}>
        <OuterBox>
          <InnerBox $open={open} $side={side}/>
        </OuterBox>
      </ButtonContainer>
    </Tooltip>);
}
